module.exports = __webpack_public_path__ + "static/media/jatiuca.1707ed53.mp3";